import React, { useState, useEffect } from "react";
import firebase from "../../helpers/firebase";
import { localStore } from "../../helpers/localStorage";
import LatexPreview from './LatexPreview';
import Alert from "@material-ui/lab/Alert";

function ProblemStatement({type}) {
  const db = firebase.firestore();
  const [statement, setStatement] = useState();
  // const [solveFor, setSolveFor] = useState(null);
  const sessionId = localStore.getSession();
  
  const [error, setError] = useState(null);

  // const extractString = str => str.match((/[a-z]/g))[0];

  const fetchStatement = () => {
    let problemStatement = db
      .collection("sessions")
      .doc(sessionId);

    problemStatement.get().then((docSnapshot) => {
      if (docSnapshot.exists) {
        let data = docSnapshot.data();
        if (data.problemStatement) {
          setStatement(data.problemStatement.latex);
          // setSolveFor(extractString(data.problemStatement.latex));
        }
      } else {
        setError("No problem statement found");
      }
    });
  };

  useEffect(() => {
    
    if(localStore.getProblemStatement()){
      setStatement(localStore.getProblemStatement().latex);
      // setSolveFor(extractString(localStore.getProblemStatement().latex));
    }
    setError(false);
    try {
      if (sessionId) {
        fetchStatement();
      }
    } catch (err) {
      console.log(err);
    }
		 // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);

  return (
    <>
    {error && <Alert className="error-top" severity="error">{error}</Alert>}
    <div className={"problemStatement "+ (type==="smallTop"?"smallTop":"")}>
      {error && <Alert severity="error">{error}</Alert>}
      <div className="exercise">
      {statement ? <LatexPreview className="math" math={statement} /> : "loading.."}
      </div>
    </div>
    </>
  );
}

export default ProblemStatement;
